import {
	API_START,
	API_END,
	FETCH_GET_EVENT_DETAILS,
	SET_GET_EVENT_DETAILS_RESULT,
	WS_EVENT,
	LIVE
} from "../actions/types";

const initialState = {
	isFetching: false,
	event: null,
	user: null
};

export default function eventReducer(state = initialState, action = {}) {
	switch (action.type) {
		case API_START:
			if (action.payload === FETCH_GET_EVENT_DETAILS) {
				return {
					...state,
					isFetching: true
				};
			}
			break;

		case SET_GET_EVENT_DETAILS_RESULT:
			return {
				...state,
				event: Object.values(action.entities?.events || {})[0] ?? state.event,
				user: Object.values(action.entities?.users || {})[0] ?? state.user
			};

		case WS_EVENT: {
			if (action.payload?.type !== LIVE || !state.event) {
				break;
			}

			const wsEvent = action.payload?.eventId;
			if (!wsEvent?._id) {
				break;
			}

			const matchesRootEvent = wsEvent._id === state.event._id;
			const matchesNestedEvent = wsEvent._id === state.event.eventId?._id;

			if (!matchesRootEvent && !matchesNestedEvent) {
				break;
			}

			return {
				...state,
				event: {
					...state.event,
					...(matchesRootEvent ? wsEvent : {}),
					eventId: {
						...(state.event.eventId ?? {}),
						...wsEvent
					}
				}
			};
		}

		case API_END:
			if (action.payload === FETCH_GET_EVENT_DETAILS) {
				return {
					...state,
					isFetching: false
				};
			}
			break;

		default:
			return state;
	}

	return state;
}
